import { render } from "./TopUkraineChannels.vue?vue&type=template&id=dc4288d6"
import script from "./TopUkraineChannels.vue?vue&type=script&lang=js"
export * from "./TopUkraineChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__